module.exports = require('./ReactS3Uploader');